module.exports = __webpack_public_path__ + "img/favicon.65322e87.png";